import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
export const ArrowBottom = props => {
    return (_jsx(SvgIcon, { width: "16", height: "9", viewBox: "0 0 16 9", fill: "none", ...props, children: _jsx("path", { d: "M8.9411e-07 1.36268L1.42739 -6.36989e-07L8 6.27465L14.5726 -6.2393e-08L16 1.36268L8 9L8.9411e-07 1.36268Z", fill: "#1C1B1F" }) }));
};
